import * as $ from 'jquery';
import 'nd.core';

    $.nd.actions = {};

    export default $.nd.actions;
